import { network } from 'services/network';
import { useQuery } from 'react-query';

const getValidationTypeDrillDown = (params) => {
    return network.post('api/bo/getValidationTypeDrillDown', params).then((response) => {
        return response.data;
    });
};
export const useQueryGetValidationTypeDrillDown = (params) => {
    return useQuery<IValidationTypeDrillDownResponse, QueryError>(
        ['getValidationTypeDrillDown', params],
        () => getValidationTypeDrillDown(params),
        {
            enabled: Boolean(params.componentId),
        },
    );
};

export interface IValidationTypeDrillDownResponse {
    headers: {
        accessor: string;
        clickable: boolean;
        colorable: boolean;
        header: string;
        order: number;
        sortable: string;
    }[];
    rows: { [key: string]: unknown }[];
    title: string;
    validationDescription: string;
}
